import dayjs from 'dayjs';
import * as types from './types';

const initialState = {
  info: {},
  promoCodeError: null,
  startTrialError: null,
  paymentMethodUpdating: false,
  subscriptionUpdating: false,
  subscribeError: null,
  subscriptionPauseUpdating: false,
  invoicePreviews: null,
  hasPendingPaymentMethod: false,
  addressUpdated: false,
  hasPaymentMethodType: false,
  isCardExpired: false,
};

export default (state = initialState, action) => {
  const plansByCode = {};
  const previewsByCode = {};
  // types: redirect_to_url, use_stripe_sdk, alipay_handle_redirect, oxxo_display_details, verify_with_microdeposits
  const { allPaymentIntents } = action.payload || {};
  // Create quick access variable to denote if user has manual ach verification in progress.
  let hasPendingPaymentMethod = false;
  let hasPaymentMethodType = false;
  let cardExpiryDate = null;
  let isCardExpired = false;
  switch (action.type) {
    case types.CREATE_SETUP_INTENT:
      return state;
    case types.CREATE_SETUP_INTENT_SUCCESS:
      return { ...state, clientSecret: action.payload };
    case types.CREATE_SETUP_INTENT_FAIL:
      return { ...state };
    case types.ATTACH_PAYMENT_METHOD:
      return { ...state, paymentMethodUpdating: true };
    case types.ATTACH_PAYMENT_METHOD_SUCCESS:
      return { ...state, paymentMethodUpdating: false };
    case types.ATTACH_PAYMENT_METHOD_FAIL:
      return { ...state, paymentMethodUpdating: false };
    case types.GET_BILLING_INFO:
      return state;
    case types.GET_BILLING_INFO_SUCCESS:
      Object.keys(action.payload.proPlans).forEach(type => {
        if (Array.isArray(action.payload.proPlans[type])) {
          action.payload.proPlans[type].forEach(plan => {
            if (plan.code) {
              plansByCode[plan.code] = plan;
            }
          });
        }
      });
      if (Array.isArray(allPaymentIntents)) {
        // allPaymentIntents is filtered from the api for only the ones that have a next action.
        allPaymentIntents.forEach(pi => {
          const { nextAction } = pi;
          if (nextAction && nextAction.type === 'verify_with_microdeposits') {
            hasPendingPaymentMethod = true;
          }
        });
      }
      hasPaymentMethodType = !!action.payload.paymentMethodType;
      if (action.payload.paymentMethodType === 'card') {
        cardExpiryDate = dayjs(`${action.payload.paymentMethodExpYear}-${action.payload.paymentMethodExpMonth}-01`)
          .endOf('month');
        isCardExpired = dayjs().isAfter(cardExpiryDate);
      }
      return {
        ...state,
        hasPendingPaymentMethod,
        hasPaymentMethodType,
        isCardExpired,
        info: { ...action.payload, plansByCode },
      };
    case types.GET_BILLING_INFO_FAIL:
      return state;
    case types.GET_INVOICE_PREVIEWS:
      return state;
    case types.GET_INVOICE_PREVIEWS_SUCCESS:
      action.payload.forEach(preview => {
        if (preview.code) {
          previewsByCode[preview.code] = preview;
        }
      });
      return { ...state, invoicePreviews: previewsByCode };
    case types.GET_INVOICE_PREVIEWS_FAIL:
      return state;
    case types.ADD_PROMO_OR_REFERRAL:
      return state;
    case types.ADD_PROMO_OR_REFERRAL_SUCCESS:
      return { ...state, promoCodeError: null };
    case types.ADD_PROMO_OR_REFERRAL_FAIL:
      return { ...state, promoCodeError: action.payload };
    case types.TRIAL:
      return state;
    case types.CANCEL_TRIAL:
      return state;
    case types.TRIAL_SUCCESS:
      return { ...state, startTrialError: null };
    case types.TRIAL_FAIL:
      return { ...state, startTrialError: action.payload };
    case types.SET_PAUSE_SUBSCRIPTION:
      return state;
    case types.SET_PAUSE_SUBSCRIPTION_SUCCESS:
      return {  ...state, userInfo: state.userInfo, ...action.payload };
    case types.SET_PAUSE_SUBSCRIPTION_FAIL:
      return state;
    case types.SUBSCRIBE:
      return { ...state, subscriptionUpdating: true };
    case types.SUBSCRIBE_SUCCESS:
      return {
        ...state,
        info: {
          ...state.info,
          ...action.payload,
        },
        subscriptionUpdating: false,
        subscribeError: null,
      };
    case types.SUBSCRIBE_FAIL:
      return { ...state, subscriptionUpdating: false, subscribeError: action.payload };
    case types.PAUSE_SUBSCRIPTION:
      return { ...state, subscriptionPauseUpdating: true };
    case types.PAUSE_SUBSCRIPTION_SUCCESS:
      return { ...state, subscriptionPauseUpdating: false };
    case types.PAUSE_SUBSCRIPTION_FAIL:
      return { ...state, subscriptionPauseUpdating: false };
    case types.RENEW_SUBSCRIPTION:
      return { ...state, subscriptionPauseUpdating: true };
    case types.RENEW_SUBSCRIPTION_SUCCESS:
      return { ...state, subscriptionPauseUpdating: false };
    case types.RENEW_SUBSCRIPTION_FAIL:
      return { ...state, subscriptionPauseUpdating: false };
    case types.UNSUBSCRIBE_SUCCESS:
      return { ...state, info: { ...state.info, ...action.payload } };
    case types.UPDATE_CUSTOMER_ADDRESS_SUCCESS:
      return { ...state, addressUpdated: true };
    case types.CLOSE_UPDATE_MODAL:
      return { ...state, addressUpdated: false };
    default:
      return { ...state };
  }
};
